export const keyStorage = {
    isLogin: 'BMA-TAX-MAP-VR_IS-LOGIN',
    isRemember: 'BMA-TAX-MAP-VR_IS-REMEMBER',
    username: 'BMA-TAX-MAP-VR_EV',
    password: 'BMA-TAX-MAP-VR_DV',
    fullName: 'BMA-TAX-MAP-VR_FULL-NAME',
    menuKey: 'BMA-TAX-MAP-VR_MENU-KEY',
    notiBadge: 'BMA-TAX-MAP-VR_NOTI-BADGE',
    pushNotification: 'BMA-TAX-MAP-VR_NOTI-PUSH',
    isPDPA: 'BMA-TAX-MAP-VR_IS-PDPA',
    isReceiveNotication: 'BMA-TAX-MAP-VR_NOTI-RECEIVE',
    userType: 'BMA-TAX-MAP-VR_USER-TYPE',
    address: 'ADDRESS',
    
    userId: 'BMA-TAX-MAP_USER-ID',
    refreshToken: 'NEKOT_HSERFER',
    accessToken: 'NEKOT_SSECCA',
    isAdmin: 'BMA-ADMIN',
};
